import { createSlice } from '@reduxjs/toolkit'
import { service } from '../shared/_services/api_service'
import { setLoading } from './loader';
import { errorHandler, successHandler } from '../shared/_helper/responseHelper';

const initialState = {
  couponsData: [],
  totalCoupons: 0,
  isOpenModal: false,
}

export const couponsSlice = createSlice({
  name: "coupons",
  initialState,
  reducers: {
    setCouponsData(state, { payload }) {
      state.couponsData = payload.result
      state.totalCoupons = payload.total
    },
    updateCouponsData(state, { payload }) {
      console.log(payload)
      const objIndex = state.couponsData.findIndex((obj) => obj._id === payload._id);
      console.log(objIndex)
      if (objIndex >= 0) {
        state.couponsData[objIndex] = payload
      }
    },
    updateCouponsImageData(state, { payload }) {
      const objIndex = state.couponsData.findIndex((obj) => obj._id === payload._id);
      if (objIndex >= 0) {
        state.couponsData[objIndex] = payload
      }
    },
    deleteCouponsData(state, { payload }) {
      const objIndex = state.couponsData.findIndex((obj) => obj._id === payload);
      if (objIndex >= 0) {
        state.couponsData.splice(objIndex, 1)
      }
    },
    pushCouponsData(state, { payload }) {
      state.couponsData.push(payload)
    },

    isOpenModal(state, { payload }) {
      state.isOpenModal = payload
    },
    ModalToggle(state, { payload }) {
      state.isOpenModal = !state.isOpenModal
    },
  }
})

export const { setCouponsData, updateCouponsData, deleteCouponsData, pushCouponsData, isOpenModal, ModalToggle, } = couponsSlice.actions;

export default couponsSlice.reducer;

export function getCoupons() {
  return async function getCouponsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.getCoupons().then(
        (response) => {
          dispatch(setLoading(false))
          dispatch(setCouponsData(response.data))
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function addCoupons(payload) {
  return async function addCouponsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.addCoupons(payload).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(pushCouponsData(response.data))
          successHandler('Added Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}
export function updateCoupons(id, data) {
  return async function updateCouponsThunk(dispatch) {
    dispatch(setLoading(true))
    try {
      await service.updateCoupons(id, data).then(
        (response) => {
          dispatch(ModalToggle())
          dispatch(setLoading(false))
          dispatch(updateCouponsData(response.data))
          successHandler('Updated Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}

export function deleteCoupons(id) {
  return async function deleteCouponsThunk(dispatch) {
    try {
      dispatch(setLoading(true))
      await service.deleteCoupons(id).then(
        (response) => {
          dispatch(deleteCouponsData(id))
          dispatch(setLoading(false))
          successHandler('Deleted Successfully')
        }, (error) => {
          dispatch(setLoading(false))
          errorHandler(error.response)
        }
      );
    } catch (err) {

    }
  }
}



